import { UserIdentityProvider } from "@core/services/user-identity.context";
import Branch from "@domain/branch/branch";
import EditBranch from "@domain/branch/edit-branch/edit-branch";
import ListBranch from "@domain/branch/list-branch/list-branch";
import NewBranch from "@domain/branch/new-branch/new-branch";
import Campaign from "@domain/campaign/campaign";
import EditCampaign from "@domain/campaign/edit-campaign/edit-campaign";
import ListCampaign from "@domain/campaign/list-campaign/list-campaign";
import NewCampaign from "@domain/campaign/new-campaign/new-campaign";
import CardCategory from "@domain/card-category/card-category";
import EditCardCategory from "@domain/card-category/edit-card-category/edit-card-category";
import ListCardCategory from "@domain/card-category/list-card-category/list-card-category";
import NewCardCategory from "@domain/card-category/new-card-category/new-card-category";
import ActivateCard from "@domain/card-series/activate-card/activate-card";
import CardSeries from "@domain/card-series/card-series";
import EditCardSeries from "@domain/card-series/edit-card-series/edit-card-series";
import ListCardSeries from "@domain/card-series/list-card-series/list-card-series";
import NewCardSeries from "@domain/card-series/new-card-series/new-card-series";
import CardSettings from "@domain/customer/card-settings/card-settings";
import Customer from "@domain/customer/customer";
import ClaimItem from "@domain/customer/list-cards/claim-item/claim-item";
import CustomerListCampaign from "@domain/customer/list-cards/list-campaigns";
import ListCards from "@domain/customer/list-cards/list-cards";
import Dashboard from "@domain/dashboard/dashboard";
import EditLevel from "@domain/level/edit-level/edit-level";
import Level from "@domain/level/level";
import ListLevel from "@domain/level/list-level/list-level";
import NewLevel from "@domain/level/new-level/new-level";
import Login from "@domain/login/login";
import Page404 from "@domain/page-error/page-404";
import RouteErrorBoundary from "@domain/page-error/route-error-boundary";
import EditCustomer from "@domain/person/edit-customer/edit-customer";
import ViewCustomerOnly from "@domain/person/edit-customer/view-customer-only";
import EditPerson from "@domain/person/edit-person/edit-person";
import FormPerson from "@domain/person/form-person/form-person";
import ListCustomer from "@domain/person/list-customer/list-customer";
import ListPerson from "@domain/person/list-person/list-person";
import NewCustomer from "@domain/person/new-customer/new-customer";
import NewPerson from "@domain/person/new-person/new-person";
import Person from "@domain/person/person";
import UnlockCustomer from "@domain/person/unlock-customer/unlock-customer";
import Public from "@domain/public/public";
import EditRegistration from "@domain/registration/edit-registration/edit-registration";
import ListRegistration from "@domain/registration/list-registration/list-registration";
import NewRegistration from "@domain/registration/new-registration/new-registration";
import Registration from "@domain/registration/registration";
import EditRequestType from "@domain/request-type/edit-request-type/edit-request-type";
import ListRequestType from "@domain/request-type/list-request-type/list-request-type";
import NewRequestType from "@domain/request-type/new-request-type/new-request-type";
import RequestType from "@domain/request-type/request-type";
import CheckProfile from "@domain/reward/check-profile/check-profile";
import EarnReward from "@domain/reward/earn-reward/earn-reward";
import EarnRewardSuccess from "@domain/reward/earn-reward-success/earn-reward-success";
import EditReward from "@domain/reward/edit-reward/edit-reward";
import ListReward from "@domain/reward/list-reward/list-reward";
import NewReward from "@domain/reward/new-reward/new-reward";
import RedeemCustom from "@domain/reward/redeem-custom/redeem-custom";
import RedeemReward from "@domain/reward/redeem-reward/redeem-reward";
import RedeemRewardDialog from "@domain/reward/redeem-reward-dialog/redeem-reward-dialog";
import RedeemRewardScanCode from "@domain/reward/redeem-reward-scan-code/redeem-reward-scan-code";
import RedeemRewardSuccess from "@domain/reward/redeem-reward-success/redeem-reward-success";
import Reward from "@domain/reward/reward";
import { SphereRedeemItemProvider } from "@domain/reward/sphere-redeem-item/sphere-redeem-item.context";
import EditRewardEvent from "@domain/reward-event/edit-reward-event/edit-reward-event";
import ListRewardEvent from "@domain/reward-event/list-reward-event/list-reward-event";
import NewRewardEvent from "@domain/reward-event/new-reward-event/new-reward-event";
import RewardEvent from "@domain/reward-event/reward-event";
import EditRewardType from "@domain/reward-type/edit-reward-type/edit-reward-type";
import ListRewardType from "@domain/reward-type/list-reward-type/list-reward-type";
import NewRewardType from "@domain/reward-type/new-reward-type/new-reward-type";
import RewardType from "@domain/reward-type/reward-type";
import EditRole from "@domain/role/edit-role/edit-role";
import ListRole from "@domain/role/list-role/list-role";
import NewRole from "@domain/role/new-role/new-role";
import Role from "@domain/role/role";
import Setting from "@domain/setting/setting";
import AuthShell from "@domain/shell/auth-shell/auth-shell";
import CustomerAuthShell from "@domain/shell/customer-auth-shell/customer-auth-shell";
import MainShell from "@domain/shell/main-shell/main-shell";
import EditTenant from "@domain/tenant/edit-tenant/edit-tenant";
import ListTenant from "@domain/tenant/list-tenant/list-tenant";
import NewTenant from "@domain/tenant/new-tenant/new-tenant";
import Tenant from "@domain/tenant/tenant";
import EditTransaction from "@domain/transaction/edit-transaction/edit-transaction";
import ListTransaction from "@domain/transaction/list-transaction/list-transaction";
import NewTransaction from "@domain/transaction/new-transaction/new-transaction";
import Transaction from "@domain/transaction/transaction";
import { SessionProvider } from "@factory/authentication/session.context";
import { ProtectedRoute } from "@shared/ui/protected-route/protected-route";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import CustomerListActivities from "./domain/customer/list-cards/list-activities";
import { ActionEnum } from "./factory/model/actions.enum";
// ROUTE IMPORT

const tenant = {
  path: "tenant",
  element: <Tenant />,
  children: [
    {
      path: "",
      element: <ListTenant />,
    },
    {
      path: "new",
      element: <NewTenant />,
    },
    {
      path: ":tenantId",
      element: <EditTenant />,
    },
  ],
};
const role = {
  path: "role",
  element: <Role />,
  children: [
    {
      path: "",
      element: <ListRole />,
    },
    {
      path: "new",
      element: <NewRole />,
    },
    {
      path: ":roleId",
      element: <EditRole />,
    },
  ],
};
const account = {
  path: "account",
  element: <Person />,
  children: [
    {
      path: "",
      element: <ListPerson />,
    },
    {
      path: "new",
      element: <NewPerson />,
    },
    {
      path: ":personId",
      element: <EditPerson />,
      children: [
        {
          path: "unlock",
          element: <UnlockCustomer />,
        },
      ],
    },
  ],
};
const transaction = {
  path: "transaction",
  element: <Transaction />,
  children: [
    {
      path: "",
      element: <ListTransaction />,
    },
    {
      path: "new",
      element: <NewTransaction />,
    },
    {
      path: ":transactionId",
      element: <EditTransaction />,
    },
  ],
};
const customer = {
  path: "customer",
  element: <Person />,
  children: [
    {
      path: "",
      element: <ListCustomer />,
    },
    {
      path: "new",
      element: <NewCustomer />,
    },
    {
      path: ":personId",
      element: <EditCustomer />,
      children: [
        {
          path: "",
          element: <FormPerson isCustomer={true} />,
        },
        {
          path: "unlock",
          element: <UnlockCustomer />,
        },
        {
          path: "transaction",
          element: <UnlockCustomer />,
        },
        transaction,
      ],
    },
  ],
};
const reward = {
  path: "",
  element: <Reward />,
  children: [
    {
      path: "",
      element: <ListReward />,
    },
    {
      path: "new",
      element: <NewReward />,
    },
    {
      path: ":rewardId",
      element: <EditReward />,
    },
  ],
};
const rewardEvent = {
  path: "reward-event",
  element: <RewardEvent />,
  children: [
    {
      path: "",
      element: <ListRewardEvent />,
    },
    {
      path: "new",
      element: <NewRewardEvent />,
    },
    {
      path: ":rewardEventId",
      element: <EditRewardEvent />,
    },
  ],
};
const campaign = {
  path: "campaign",
  element: <Campaign />,
  children: [
    {
      path: "",
      element: <ListCampaign />,
      children: [
        {
          path: "redeem-custom",
          element: <RedeemCustom />,
        },
        {
          path: "redeem-code",
          element: <RedeemRewardScanCode />,
        },
        {
          path: "redeem-code-success",
          element: <RedeemRewardSuccess />,
        },
        {
          path: "redeem/:campaignId",
          element: <RedeemRewardDialog />,
        },
        {
          path: "redeem/:campaignId/success",
          element: <RedeemRewardSuccess />,
        },
      ],
    },
    {
      path: "new",
      element: <NewCampaign />,
    },
    {
      path: ":campaignId",
      element: <EditCampaign />,
    },
  ],
};
const rewardType = {
  path: "",
  element: <RewardType />,
  children: [
    {
      path: "",
      element: <ListRewardType />,
    },
    {
      path: "new",
      element: <NewRewardType />,
    },
    {
      path: ":rewardTypeId",
      element: <EditRewardType />,
    },
  ],
};
const requestType = {
  path: "request-type",
  element: <RequestType />,
  children: [
    {
      path: "",
      element: <ListRequestType />,
    },
    {
      path: "new",
      element: <NewRequestType />,
    },
    {
      path: ":requestTypeId",
      element: <EditRequestType />,
    },
  ],
};
const branch = {
  path: "branch",
  element: <Branch />,
  children: [
    {
      path: "",
      element: <ListBranch />,
    },
    {
      path: "new",
      element: <NewBranch />,
    },
    {
      path: ":branchId",
      element: <EditBranch />,
    },
  ],
};
const cardSeries = {
  path: "card-series",
  element: <CardSeries />,
  children: [
    {
      path: "",
      element: <ListCardSeries />,
    },
    {
      path: "activate",
      element: <ActivateCard />,
    },
    {
      path: ":new",
      element: <NewCardSeries />,
    },
    {
      path: ":cardSeriesId",
      element: <EditCardSeries />,
    },
  ],
};
const level = {
  path: "level",
  element: <Level />,
  children: [
    {
      path: "",
      element: <ListLevel />,
    },
    {
      path: "new",
      element: <NewLevel />,
    },
    {
      path: ":levelId",
      element: <EditLevel />,
    },
  ],
};
const cardCategory = {
  path: "card-category",
  element: <CardCategory />,
  children: [
    {
      path: "",
      element: <ListCardCategory />,
    },
    {
      path: "new",
      element: <NewCardCategory />,
    },
    {
      path: ":cardCategoryId",
      element: <EditCardCategory />,
    },
  ],
};
const registration = {
  path: "registration",
  element: <Registration />,
  children: [
    {
      path: "",
      element: <ListRegistration />,
    },
    {
      path: "new",
      element: <NewRegistration />,
    },
    {
      path: ":registrationId",
      element: <EditRegistration />,
    },
  ],
};
// ROUTE DEFINITION

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainShell />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: "login", element: <Login /> },
      {
        path: "public",
        element: <Public />,
        children: [
          {
            path: ":tenantSlug",
            element: <NewRegistration />,
          },
        ],
      },
      {
        path: "customer",
        element: (
          <UserIdentityProvider>
            <SessionProvider>
              <ProtectedRoute>
                <CustomerAuthShell />
              </ProtectedRoute>
            </SessionProvider>
          </UserIdentityProvider>
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
          {
            path: "",
            element: <Customer />,
            children: [
              {
                path: "",
                element: <ListCards />,
                children: [
                  {
                    path: "",
                    element: <CustomerListCampaign />,
                    children: [
                      {
                        path: "redeem",
                        element: <ClaimItem />,
                      },
                    ],
                  },
                  {
                    path: "activity",
                    element: (
                      <CustomerListActivities action={ActionEnum.Earn} />
                    ),
                  },
                  {
                    path: "redeemed-items",
                    element: (
                      <CustomerListActivities action={ActionEnum.Redeem} />
                    ),
                  },
                ],
              },
              {
                path: "new-card",
                element: <ActivateCard />,
              },
              {
                path: "card-settings",
                element: <CardSettings />,
              },
              {
                path: "account/:personId",
                element: <ViewCustomerOnly />,
              },
            ],
          },
        ],
      },
      {
        path: "business",
        element: (
          <UserIdentityProvider>
            <SessionProvider>
              <ProtectedRoute>
                <AuthShell />
              </ProtectedRoute>
            </SessionProvider>
          </UserIdentityProvider>
        ),
        errorElement: <RouteErrorBoundary />,
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
          {
            path: "check-profile",
            element: <CheckProfile />,
          },
          {
            path: "earn",
            element: <EarnReward />,
          },
          {
            path: "earn-success/:cardAlias",
            element: <EarnRewardSuccess />,
          },
          {
            path: "redeem-old",
            element: (
              <SphereRedeemItemProvider>
                <RedeemReward />
              </SphereRedeemItemProvider>
            ),
            children: [
              {
                path: "success",
                element: <RedeemRewardSuccess />,
              },
            ],
          },
          customer,
          tenant,
          account,
          rewardEvent,
          campaign,
          role,
          requestType,
          transaction,
          branch,
          cardSeries,
          registration,
          {
            path: "setting",
            element: <Setting />,
            children: [reward, level, cardCategory],
          },
          // ROUTE ADD
        ],
      },
      { path: "404", element: <Page404 /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
]);
export function AppRoute() {
  return <RouterProvider router={router} />;
}
